<template>
  <b-modal
    id="pos-cash-payment-modal"
    :title="trans('cash')"
    no-close-on-backdrop
    no-enforce-focus
    no-close-on-esc
    hide-header-close
    :ok-title="trans('pay_now')"
    :ok-disabled="!canPay"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onPay"
  >
    <b-form-group :label="trans('amount')">
      <h3><dollar :value="amount"></dollar></h3>
    </b-form-group>

    <b-row>
      <b-col>
        <b-form-group :label="trans('amount')">
          <b-form-input
            v-model="cash_amount"
            lazy-formatter
            :formatter="formatter"
            :state="isCashAmountValid"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="trans('change')">
          <b-form-input
            :value="cashChange"
            readonly
            class="bg-light"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div>
      <b-button variant="primary" class="square" @click="cash_amount = roundedAmount">
        <dollar :value="roundedAmount"></dollar>
      </b-button>
      <b-button variant="success" class="square ml-2" @click="onAdd(1)">
        <i class="fa fa-fw fa-plus"></i>
        <dollar :value="1"></dollar>
      </b-button>
      <b-button variant="success" class="square ml-2" @click="onAdd(5)">
        <i class="fa fa-fw fa-plus"></i>
        <dollar :value="5"></dollar>
      </b-button>
      <b-button variant="success" class="square ml-2" @click="onAdd(10)">
        <i class="fa fa-fw fa-plus"></i>
        <dollar :value="10"></dollar>
      </b-button>
      <b-button variant="success" class="square ml-2" @click="onAdd(20)">
        <i class="fa fa-fw fa-plus"></i>
        <dollar :value="20"></dollar>
      </b-button>
    </div>

    <b-form-group v-if="!invoice.is_no_client && !noSendEmail">
      <b-form-checkbox v-model="send_email">
        {{ trans('send_confirmation_email_to').replace(':email', invoice.recipient.email) }}
      </b-form-checkbox>
    </b-form-group>
    <br v-if="invoice.is_no_client" />
  </b-modal>
</template>

<script>
  import Dollar from './../billing/Dollar'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      amount: Number|String,
      noSendEmail: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Dollar,
    },
    data() {
      return {
        trans: trans,
        cash_amount: null,
        send_email: !this.invoice.is_no_client,
      }
    },
    computed: {
      isCashAmountValid() {
        return this.cash_amount >= this.amount
      },
      roundedAmount() {
        return Math.ceil(this.amount / 10)*10
      },
      cashChange() {
        if (!this.cash_amount || this.cash_amount < this.amount) return null
        return numeral(_.round(this.cash_amount - this.amount, 2)).format('1,000.00')
      },
      canPay() {
        return this.isCashAmountValid
      },
    },
    methods: {
      onAdd(amount) {
        if (!this.cash_amount) {
          this.cash_amount = amount
        } else {
          this.cash_amount += amount
        }
      },
      onShown() {
        this.cash_amount = null
        this.send_email = !this.invoice.is_no_client
      },
      formatter(value) {
        if (value === null || value === undefined || value === '') return ''
        return numeral(value).format('0.00')
      },
      onPay() {
        this.$emit('paying', this.cash_amount, this.send_email)
        this.$bvModal.hide('pos-cash-payment-modal')
      },
    },
    mounted() {
      window.posCashPaymentModal = this
    },
  }
</script>